import { usePermissions } from 'contexts';
import React, { useEffect, useState } from 'react';
import ReportService from 'services/reports.service';
import { openModal } from 'store/modals/modals.slice';
import {
  getPoliciesThunk,
  getPolicyThunk,
} from 'store/policies/policies.thunks';

import events from '../../../shared/constants/events';
import { MODAL_POLICY } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { vocabulary } from '../../../vocabulary/german';
import { CreateButton } from '../../buttons/create-button/create-button';
import PoliciesList from '../../lists/policies-list/policies-list';
import { Container } from '../../template/container/container';
import { NotFoundMessage } from '../../template/not-found-message/not-found-message';
import { PageHeader } from '../../template/page-header/page-header';
import { Spinner } from '../../template/spinner/spinner';

const PoliciesPage = () => {
  const dispatch = useAppDispatch();

  const policies = useAppSelector((state) => state.policies);
  const { isGetPoliciesThunkPending } = policies;
  const permissions = usePermissions();
  const [isLocked, setIsLocked] = useState(false);

  const unlock = () => {
    setIsLocked(false);
  };

  useEffect(() => {
    dispatch(getPoliciesThunk());
    document.body.addEventListener(events.UNLOCK.name, unlock);

    return document.body.removeEventListener(events.UNLOCK.name, unlock);
  }, [dispatch]);

  const handleClick = () => {
    dispatch(openModal({ name: MODAL_POLICY }));
  };

  const handleEdit = (item) => {
    if (item.id) {
      dispatch(getPolicyThunk(item.id));
      dispatch(openModal({ name: MODAL_POLICY }));
    }
  };

  const downloadShortPoliciesReport = (type) => {
    setIsLocked(true);
    const reportsService = new ReportService();
    reportsService.downloadShortPoliciesReport(type);
  };

  const renderPolicyButton = (): JSX.Element | undefined => {
    if (permissions.permissions.createNew === true) {
      return (
        <CreateButton
          text={vocabulary.buttons.createNewPolicy}
          onClick={() => handleClick()}
        />
      );
    }
  };

  const renderEntityPanels = () => {
    if (isGetPoliciesThunkPending) {
      return <Spinner />;
    }

    if (policies.list.length !== 0) {
      return (
        <div className={'entities-list'}>
          <PoliciesList policies={policies.list} onSelect={handleEdit} />
          {renderPolicyButton()}
        </div>
      );
    }

    return (
      <>
        <NotFoundMessage
          message={`Nicht gefunden: Politikbereiche konnten nicht gefunden werden.`}
        />
        {renderPolicyButton()}
      </>
    );
  };

  return (
    <React.Fragment>
      <div className={'page-content'}>
        <PageHeader
          title={vocabulary.labels.policiesAreas}
          btnText={vocabulary.buttons.reports.downloadReportPdf}
          downloadReport={downloadShortPoliciesReport}
          btnTextDocx={vocabulary.buttons.reports.downloadReportDocx}
        />
        <Container>{renderEntityPanels()} </Container>
      </div>
      {isLocked && (
        <Spinner isFullSize message={vocabulary.preloader.waitForReport} />
      )}
    </React.Fragment>
  );
};

export default PoliciesPage;
